import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=625f810b&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=625f810b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f810b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625f810b')) {
      api.createRecord('625f810b', component.options)
    } else {
      api.reload('625f810b', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=625f810b&scoped=true&", function () {
      api.rerender('625f810b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u1eON4XuzoIb/JS/teamMember.vue"
export default component.exports